var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 346H16V496H496V346Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V166H496V16Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 326H16V346H496V326Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 166H16V186H496V166Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 181H16V331H496V181Z",
    fill: "#E74C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 194V318H218.317C224.267 338.667 244.1 380 256 380C267.9 380 287.733 338.667 293.683 318H494V194H293.683C287.733 173.333 267.9 132 256 132C244.1 132 224.267 173.333 218.317 194H18Z",
    fill: "#E74C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.041 391.555H257.959V168.85C261.878 164.083 261.878 156.931 261.878 149.78C261.878 145.012 261.878 125.942 256 105.291C250.122 125.942 250.122 145.012 250.122 149.78C250.122 156.931 250.122 164.083 254.041 168.85V391.555Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.52665
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.041 391.555H257.959V168.85C261.878 164.083 261.878 156.931 261.878 149.78C261.878 145.012 261.878 125.942 256 105.291C250.122 125.942 250.122 145.012 250.122 149.78C250.122 156.931 250.122 164.083 254.041 168.85V391.555Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M293.226 316.644C299.103 297.574 303.022 278.503 303.022 259.433C303.022 240.363 299.103 221.293 293.226 202.223C287.348 221.293 283.429 240.363 283.429 259.433C283.429 278.503 287.348 297.574 293.226 316.644Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M256 273.736C260.328 273.736 263.837 267.333 263.837 259.433C263.837 251.534 260.328 245.131 256 245.131C251.672 245.131 248.163 251.534 248.163 259.433C248.163 267.333 251.672 273.736 256 273.736Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M257.959 273.379C257.959 273.379 265.796 292.449 265.796 323.438C265.796 354.427 257.959 373.497 257.959 373.497V273.379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.ee96bd20aff3f0d06a1396302c185979.svg";
export { ForwardRef as ReactComponent };